export default __webpack_public_path__ + "static/media/sg8.858082e1.png";